import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchFollowers } from '../../actions/fetch-followers';
import { clearFollowers } from '../../actions/clear-followers';
import { fetchUserAndRedirect } from '../../actions/fetch-user-and-redirect';
import { redirectTo404 } from '../../actions/redirect-to-404';
import DefaultDesktopLayout from '../../components/default-desktop-layout';
import AnimatedLoader from '../../components/animated-loader';
import MemberList from '../../components/member-list';
import EmptyState from '../../components/empty-states';
import InfiniteListLoader from '../../components/infinite-list-loader';
import Loader from '../../components/loader';
import { MEMBERS_PER_PAGE } from '../../constants/pagination';
import AppLoaded from '../../components/app-loaded';
import withTranslate from '../../hoc/with-translate';
import { getCurrentUserSlug } from '../../selectors/current-user-selectors';
import { getIsFollowersLoading } from '../../selectors/is-loading-selectors';
import { getFollowers, getFollowerCount } from '../../selectors/followers-selectors';
import { getUserBySlug } from '../../selectors/user-selectors';

const reset = () => ({ page: 1 });
const increment = state => ({ page: state.page + 1 });

export class FollowersPage extends Component {
  static fetchData = ({ store, params, search }) =>
    store
      .dispatch(fetchUserAndRedirect(params.userSlug, search))
      .then(user =>
        store.dispatch(
          fetchFollowers({
            userId: user._id,
            page: 1,
            pageSize: MEMBERS_PER_PAGE,
          })
        )
      )
      .catch(() => store.dispatch(redirectTo404(search)));

  state = { page: 1 };

  componentDidMount = () => this.fetchFollowers();
  componentWillUnmount = () => this.props.clearFollowers();

  componentWillReceiveProps = ({ userId }) => {
    if (this.props.userId !== userId) {
      this.props.clearFollowers();
      this.setState(reset, () => this.fetchFollowers(userId));
    }
  };

  fetchFollowers = (userId = this.props.userId, page = this.state.page) =>
    this.props.fetchFollowers({
      userId,
      page,
      pageSize: MEMBERS_PER_PAGE,
    });

  handleLoad = () => this.setState(increment, this.fetchFollowers);

  renderEmptyState = () => {
    const { isCurrentUser, t } = this.props;
    const suffix = isCurrentUser ? '-current-user' : '';
    return (
      <EmptyState
        title={t(`followers-page.empty-state-title${suffix}`)}
        content={t(`followers-page.empty-state-content${suffix}`)}
      />
    );
  };

  renderMemberList = () => {
    const { isLoading, followers, count } = this.props;
    return (
      <DefaultDesktopLayout>
        <MemberList members={followers}/>
        <InfiniteListLoader
          onLoad={this.handleLoad}
          loader={<Loader/>}
          isLoading={isLoading}
          hasMore={followers.length < count}
        />
      </DefaultDesktopLayout>
    );
  };

  render = () => {
    const { isLoading, followers } = this.props;
    return (
      <div>
        <AnimatedLoader isLoading={isLoading && !followers.length}>
          {followers.length ? this.renderMemberList() : this.renderEmptyState()}
        </AnimatedLoader>
        <AppLoaded/>
      </div>
    );
  };
}

FollowersPage.propTypes = {
  fetchFollowers: PropTypes.func.isRequired,
  clearFollowers: PropTypes.func.isRequired,
  isCurrentUser: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
  params: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  followers: PropTypes.array,
  t: PropTypes.func.isRequired,
  count: PropTypes.number.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  isCurrentUser: getCurrentUserSlug(state) === ownProps.params.userSlug,
  userId: getUserBySlug(state, ownProps.params.userSlug)._id,
  isLoading: getIsFollowersLoading(state),
  followers: getFollowers(state),
  count: getFollowerCount(state),
});

const mapDispatchToProps = {
  fetchFollowers,
  clearFollowers,
};

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps), withTranslate)(FollowersPage);



// WEBPACK FOOTER //
// ./app/containers/followers-page/followers-page.js